import { useEffect, useState, useCallback } from 'react';
import './style.css';
import { switchVariantStatus } from 'src/services/utils/index';
import Form from 'react-bootstrap/Form';
import { useUserContext } from 'src/contexts/UserContext';
import AsideNavbar from 'src/components/AsideNavbar';
import PortalNavBar from 'src/components/PortalNavbar';
import { Link, useParams } from 'react-router-dom';
import ModalComponent from 'src/components/Modal/ModalComponent';
import useModal from 'src/services/hooks/useModal';
import { getVariantDataComponent } from './components/getVariantDataComponent';
import { VariantsService } from 'src/services/Variants';

export function VariantDetails() {
  const { id, variantid: variantId } = useParams();
  const { token } = useUserContext();

  const [variantData, setVariantData] = useState();
  const [originalProductInfo, setOriginalProductInfo] = useState();

  const [openModalComp, setOpenModal] = useModal();

  const getProductVariant = useCallback(async () => {
    const response = await VariantsService.getProductVariant({
      productId: id,
      variantId,
    });
    setVariantData(response.data);
  }, [id, variantId]);

  useEffect(() => {
    getProductVariant();
  }, [getProductVariant]);

  const fetchProductInfo = useCallback(async () => {
    const response = await VariantsService.getProductInfo({ productId: id });
    setOriginalProductInfo(response.data);
  }, [id]);

  useEffect(() => {
    if (variantData) {
      fetchProductInfo();
    }
  }, [variantData, fetchProductInfo]);

  return (
    <>
      {Boolean(variantData && originalProductInfo) && (
        <div className="ms-2 select-sticky-mobile align-items-center">
          <div className="select-sticky-mobile_inner">
            <Form.Select
              onChange={event => {
                const { value } = event.target;
                const numberValue = Number(value);
                if (numberValue !== 0) window.location.replace(value);
              }}
              className="ms-2 py-2"
            >
              <option value="0" key={id}>
                {variantData.variant.title}
              </option>
              {originalProductInfo.variants
                .filter(variant => variant.id !== variantData.variant.id)
                .map(variant => {
                  const { id, title } = variant;

                  return (
                    <option value={id} key={id}>
                      {title}
                    </option>
                  );
                })}
            </Form.Select>
          </div>
        </div>
      )}

      <div id="wrapper">
        <AsideNavbar />
        <div id="page-wrapper">
          <PortalNavBar />
          <div className="mt-5 mt-md-0 wrapper wrapper-content animated fadeInRight">
            <Link to={`/product/details/${id}`} className="change-link">
              <span>
                <i className="fas fa-arrow-left" aria-hidden="true" /> voltar
              </span>
            </Link>
            {typeof variantData === 'undefined' ? (
              <div className="spinner-border m-5" role="status" />
            ) : variantData ? (
              getVariantDataComponent(variantData, originalProductInfo, token, {
                setOpenModal,
              })
            ) : (
              'No product'
            )}
          </div>
        </div>
        {/* Modal Variants */}
        {openModalComp && (
          <ModalComponent
            title={
              // TODO: use enum
              openModalComp.action === 'activate'
                ? 'Ativação de Variante'
                : 'Desativação de Variante'
            }
            closeModal={() => setOpenModal(false)}
          >
            {openModalComp.action === 'activate' ? (
              <p className="card-text pb-3">
                O produto ficará disponível para todos os lojistas da Inventa
                realizarem pedidos.
                <br /> Deseja ativar o produto?
              </p>
            ) : (
              <p className="card-text pb-3">
                O produto será desativado temporariamente do seu catálogo
                virtual na Inventa, impedindo os lojistas de comprarem este item
                até que o mesmo volte ao estoque e seja reativado por você.
                <br /> Deseja desativar o produto?
              </p>
            )}

            <button
              className="btn btn-confirm"
              onClick={() => {
                const { productID, variantID, action, token } = openModalComp;
                switchVariantStatus(productID, variantID, action, token);
                const newProduct = variantData;
                newProduct.variant.inventory_policy =
                  action === 'activate' ? 'continue' : 'deny';
                setVariantData(newProduct);
                setOpenModal(false);
              }}
            >
              {openModalComp.action === 'activate'
                ? 'Ativar Produto'
                : 'Desativar produto'}
            </button>
          </ModalComponent>
        )}
      </div>
    </>
  );
}
